import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'
import {
	breakpoints,
	colors,
	radius,
	shadows,
	spacing,
	sizing,
	zIndex,
} from '@/styles/designTokens'

// SwipeableDrawer Paper sx — mobile bottom sheet for non-edit order settings modal.
// Do NOT set position — MUI needs position:fixed on the Paper to anchor to the viewport bottom.
export const orderSettingsDrawerPaperSx = {
	backgroundColor: colors.surfaceWhite,
	borderRadius: `${radius.sheet}px ${radius.sheet}px 0 0`,
	width: '100%',
	maxWidth: 480,
	maxHeight: '90vh',
	overflow: 'hidden',
	display: 'flex',
	flexDirection: 'column' as const,
	boxShadow: shadows.modal,
	margin: '0 auto',
	[`@media (min-width: ${breakpoints.desktopSm}px)`]: {
		borderRadius: `${radius.sheet}px`,
		left: 0,
		right: 0,
		bottom: `${spacing.lg}px`,
		marginLeft: 'auto',
		marginRight: 'auto',
	},
} as const

export { DrawerPuller } from '@/components/common/ui/DrawerPuller.styled'

export const Backdrop = styled(Box, { shouldForwardProp: (prop) => prop !== 'isEdit' })<{
	isEdit: boolean
}>(({ theme, isEdit }) => ({
	position: 'fixed',
	inset: 0,
	backgroundColor: 'rgba(0,0,0,0.25)',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	zIndex: zIndex.modal,
	...(!isEdit && {
		[theme.breakpoints.down('md')]: {
			alignItems: 'flex-end',
			justifyContent: 'flex-start',
		},
	}),
}))

export const Card = styled(Box, {
	shouldForwardProp: (prop) => prop !== 'isEdit' && prop !== 'width',
})<{
	width: number
	isEdit: boolean
}>(({ theme, width, isEdit }) => ({
	position: 'relative',
	backgroundColor: colors.surfaceWhite,
	borderRadius: '16px',
	width: `${width}px`,
	maxWidth: '100%',
	maxHeight: '90vh',
	overflow: 'hidden',
	display: 'flex',
	flexDirection: 'column',
	boxShadow:
		'0px 1px 3px rgba(0,0,0,0.2), 0px 2px 1px rgba(0,0,0,0.12), 0px 1px 1px rgba(0,0,0,0.14)',
	margin: '16px',
	...(!isEdit && {
		[theme.breakpoints.down('md')]: {
			borderRadius: `${radius.sheet}px ${radius.sheet}px 0 0`,
			width: '100%',
			maxWidth: '100%',
			margin: 0,
			maxHeight: sizing.modalSheetMaxHeight,
		},
	}),
}))

export const HeaderBar = styled(Box)({
	display: 'flex',
	alignItems: 'center',
	gap: '12px',
	padding: '0 24px',
	height: '72px',
	borderBottom: `1px solid ${colors.divider}`,
	flexShrink: 0,
})
